/**
 * Created by sombra.mac5 on 12/5/16.
 */
angular.module('main').directive('btnDeleteJob', () => ({
	restrict: 'AE',
	scope: {
		text: '@snText'
	},
	template:
		'<button class="btn btn-default"><img src="https://app.studioninja.co/build/release-pipeline-51/resources/dist/assets/images/icons/job-delete.png" class="fi fi-jobDelete"/>{{text}}</button>',
	replace: true,
	transclude: true
}));



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnDeleteJob.js